import { BodyTextM, cs } from "@repo/ui";
import { type FC } from "react";
import { Trans } from "react-i18next";
import { InternalLink } from "../../../components/Link";
import { Seo } from "../../../components/SEO";
import withProtection from "../../../highOrderComponents/withProtection";

const GDPR_URL = "https://www.nn.cz/ochrana-osobnich-udaju/";

export const Title: FC = () => {
	return <>{cs.profile.personalInformation.header}</>;
}

const Info: FC = () => {
	return (
		<BodyTextM>
			<Trans
				i18nKey="profile.personalInformation.content"
				components={{
					gdprLink: <InternalLink to={GDPR_URL} target="_blank" rel="noreferrer noopener" />,
				}}
			/>
		</BodyTextM>
	);
};

export const Head: FC = () => (
	<Seo title="Informace">
		<meta name="robots" content="noindex" />
	</Seo>
);

export default withProtection(Info);
